import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import TextField from '@material-ui/core/TextField'
import { useTranslation } from 'react-i18next'
import Paper from '@material-ui/core/Paper'
import withAccessControl from '../HOC/AccessControl'
import { ACL_COMPONENTS } from '../../config'

const useStyles = makeStyles(theme => ({
    textField: {
        width: '100%',
        marginRight: 0,
        marginLeft: 0
    },
    autocompleteResultWrapper: {
        position: 'relative',
        textAlign: 'center',
        zIndex: 2
    },
    autocompleteResult: {
        position: 'relative', // Could be 'absolute' for hovering autosuggest-result-list
        padding: theme.spacing(3),
        width: '100%'
    }
}))

// Google search options
const searchOptions = {
    componentRestrictions: { country: 'ch' },
    types: ['address']
}

const addressObject = {
    street: '',
    number: '',
    zip: '',
    city: ''
}

const checkMapsAPILoaded = () => {
    if (
      !window.google ||
      !window.google.maps ||
      !window.google.maps.places ||
      !window.google.maps.places.AutocompleteService
    ) {
      console.warn("Google-Maps-API not loaded.");
      return;
    }
}

const GooglePlacesAutosuggestStreet = props => {
    const classes = useStyles()
    const { t } = useTranslation()
    const { formValueSetter, presetValue } = props
    const [input, setInput] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const placesDiv = useRef(null);
    
    // TODO: New places api handling
    //       See: https://developers.google.com/maps/documentation/javascript/legacy/places-migration-overview
    //const placeRef = useRef(null);
    //useEffect(() => {
    //    const { Place } = window.google.maps.importLibrary("places").then(Place => {
    //        placeRef.current = Place;
    //    });
    //}, [])

    useEffect(() => {
        placesDiv.current = document.createElement('div');
    })

    useEffect(() => {
        if (typeof presetValue !== 'undefined' && presetValue !== '') {
            formValueSetter(presetValue)
        }
    }, [presetValue, formValueSetter])

    useEffect(() => {
        if (!input) {
            setSuggestions([]);
            return;
        }

        checkMapsAPILoaded();

        // NOTE: Deprecated: window.google.maps.places.AutocompleteService is deprecated, but still works
        //       See: https://developers.google.com/maps/documentation/javascript/places-migration-overview
        const service = new window.google.maps.places.AutocompleteService();
        service.getPlacePredictions({ input, ...searchOptions }, (predictions, status) => {
            if (status === "OK" && predictions) {
                setSuggestions(predictions);
            } else {
                setSuggestions([]);
            }
        });
    }, [input]);

    const handleAddressSelect = (placeId) => {
        checkMapsAPILoaded();
        
        // NOTE: Deprecated: window.google.maps.places.PlacesService is deprecated, but still works
        //       See: https://developers.google.com/maps/documentation/javascript/places-migration-overview
        const service = new window.google.maps.places.PlacesService(placesDiv.current);

        service.getDetails({ placeId }, (place, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                place.address_components.map(item => {
                    if (item.types[0] === 'street_number') {
                        addressObject.number = item.long_name
                    }

                    if (item.types[0] === 'route') {
                        addressObject.street = item.long_name
                    }

                    if (item.types[0] === 'postal_code') {
                        addressObject.zip = item.long_name
                    }

                    if (item.types[0] === 'locality') {
                        addressObject.city = item.long_name
                    }
                    return item
                })

                props.formValueSetter(addressObject.street + " " + addressObject.number);
                props.onSuggestionSelect({ addressObject })
                setSuggestions([]);
                setInput('');
            }
        });
    };

    return (
        <div>
            <TextField
            value={input || props.formValue || ''}
            onChange={(e) => setInput(e.target.value)}
            id='inputStreet'
            label={t('form.label.street')}
            className={classes.textField}
            margin='normal'
            variant='outlined'
            error={props.autoSuggestError}
            helperText={props.helperText}
            disabled={props.disabled}
            />
            {suggestions.length > 0 && (
                <div className={classes.autocompleteResultWrapper}>
                    <Paper className={classes.autocompleteResult}>
                    <List dense>
                        {suggestions.map((suggestion, index) => (
                        <ListItem
                            key={index}
                            id={`autocomplete-places-result-${index}`}
                            button
                            component='a'
                            place_id={suggestion.place_id}
                            onClick={() => handleAddressSelect(suggestion.place_id)}
                        >
                            {suggestion.description}
                        </ListItem>
                        ))}
                    </List>
                    </Paper>
                </div>
            )}
        </div>
    );
};

export default withAccessControl(
  GooglePlacesAutosuggestStreet,
  ACL_COMPONENTS.GOOGLE_PLACES_AUTOSUGGEST_FIELD
)